import React from 'react';
import { useIntl } from 'react-intl';
import BlockDataForm from '@plone/volto/components/manage/Form/BlockDataForm';
import withObjectBrowser from '@plone/volto/components/manage/Sidebar/ObjectBrowser';

import { mpfServicosDestaqueSchema } from './schema';

/**
 * Formulário da barra lateral. Sob `withObjectBrowser` porque o campo
 * `servico` de cada item é um `object_browser` aninhado num `object_list`
 * (mesmo padrão de `AcoesRapidas/Data.tsx`).
 */
const Data = (props: any) => {
  const { block, data, onChangeBlock } = props;
  const intl = useIntl();
  const schema = mpfServicosDestaqueSchema({
    intl,
    activeObject: props.activeObject,
    setActiveObject: props.setActiveObject,
  });

  return (
    <BlockDataForm
      {...props}
      schema={schema}
      title={schema.title}
      onChangeField={(id: string, value: unknown) =>
        onChangeBlock(block, { ...data, [id]: value })
      }
      onChangeBlock={onChangeBlock}
      formData={data}
      block={block}
    />
  );
};

export default withObjectBrowser(Data);
